module.exports = __webpack_public_path__ + "static/dsgvo-bd5760668cb138868397b076360ecced.jpg";